<template>
  <div>
    <MarketplaceRatesHead
        :showFilter="showFilter"
        :selectedNow="selectedNow"
        :countFilterParams="countFilterParams"
        :userShopId="userShopId"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @changeFilter="changeFilter"
        @changeTab="(data) => $emit('changeTab', data)"
        @selectAll="selectAll"
        @reload="$emit('reload')"
        @massThermalPrint="$emit('massThermalPrint')"
    />

    <div class="table-filter-wrap">

      <MarketplaceRatesFilter
          v-if="isAdmin"
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="changeFilter"
          @resetFilter="$emit('resetFilter')"
      />

      <MarketplaceRatesTable
          :selectedNow="selectedNow"
          :countFilterParams="countFilterParams"
          :userShopId="userShopId"
          @changeSort="data => $emit('changeSort', data)"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          @downloadFiles="type => $emit('downloadFiles', type)"
          @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import MarketplaceRatesHead from "./MarketplaceRatesHead/MarketplaceRatesHead";
  import MarketplaceRatesTable from "./MarketplaceRatesTable/MarketplaceRatesTable";
  import MarketplaceRatesFilter from "./MarketplaceRatesFilter/MarketplaceRatesFilter";

  export default {
    name: "MarketplaceRatesTableUser",

    components: {
      MarketplaceRatesHead,
      MarketplaceRatesTable,
      MarketplaceRatesFilter,
    },

    props: {
      countFilterParams: Number,
      userShopId: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeFilter(data) {
        this.$emit('changeFilter', data)
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
